import React, { useEffect, useState } from "react"
import { Field, isDirty, resetSection } from "redux-form"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { CustomRadioField } from "components/RenderInput"
import "components/style.scss"
import { FORM_NAMES, IMAGES } from "constants/index"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { connect } from "react-redux"

const LayoutTab = ({ tabIsActive, isDirty, resetForm, handleSave }) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>Layout</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>Select layout:</Col>
          </Row>
          <Row className="my-3">
            <Col className="d-flex my-2">
              <Row>
                <Col>
                  <Field
                    name="layout"
                    value="1"
                    label="Button Stack"
                    type="radio"
                    component={CustomRadioField}
                    img={IMAGES.EXP_TEMPLATE1}
                  />
                </Col>
                <Col className="mx-3">
                  <Field
                    name="layout"
                    value="2"
                    label="Dialpad"
                    type="radio"
                    component={CustomRadioField}
                    img={IMAGES.EXP_TEMPLATE2}
                  />
                </Col>
                <Col className="mx-3">
                  <Field
                    name="layout"
                    value="3"
                    label="Curbside"
                    type="radio"
                    component={CustomRadioField}
                    img={IMAGES.EXP_TEMPLATE3}
                  />
                </Col>
                <Col className="mx-3">
                  <Field
                    name="layout"
                    value="4"
                    label="Simple Stack"
                    type="radio"
                    component={CustomRadioField}
                    img={IMAGES.EXP_TEMPLATE4}
                  />
                </Col>
                {/* <Col className="mx-3">
                <Field
                name="layout"
                value="5"
                label="Piano Keys"
                type="radio"
                component={CustomRadioField}
                img={IMAGES.EXP_TEMPLATE5}
                />
              </Col> */}
                <Col className="mx-3">
                  <Field
                    name="layout"
                    value="6"
                    label="Circles"
                    type="radio"
                    component={CustomRadioField}
                    img={IMAGES.EXP_TEMPLATE6}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.EXPERIENCE)(state, ...["setup.layout"]),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(resetSection(FORM_NAMES.EXPERIENCE, ...["setup"])),
})

export default connect(mapStateToProps, mapDispatchToProps)(LayoutTab)
